// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-box-body {\n  width: 480px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
